import { AppState } from '@/store/state';
import { UiState } from '@/store/ui/state';
import { Component, HostBinding, OnInit } from '@angular/core';
import { Store } from '@ngrx/store';
import { Observable, Subject } from 'rxjs';
import { CommonService } from '@modules/shared/services/common.service';
import { AuthService } from '@services/auth.service';
import { NotificationService } from '@modules/shared/services/services/notification.service';

const BASE_CLASSES = 'main-sidebar elevation-4';
@Component({
    selector: 'app-menu-sidebar',
    templateUrl: './menu-sidebar.component.html',
    styleUrls: ['./menu-sidebar.component.scss']
})
export class MenuSidebarComponent implements OnInit {
    @HostBinding('class') classes: string = BASE_CLASSES;
    public ui: Observable<UiState>;
    public showMiniLogoIcon: boolean = false;
    public onMouseOver: boolean = false;
    public user;
    public menu = MENU;
    savedMenu = this.menu;
    public accessControl;

    constructor(
        private store: Store<AppState>,
        private commonService: CommonService,
        private _authService: AuthService,
        private notificationService: NotificationService
    ) {
        this._authService.userAccess = new Subject();
        this._authService.userAccess.subscribe((res) => {
            this.setSideMenu(res);
        });
    }

    ngOnInit() {
        this.ui = this.store.select('ui');
        this.ui.subscribe((state: UiState) => {
            this.classes = `${BASE_CLASSES} ${state.sidebarSkin}`;
            if (state.screenSize >= 768) {
                this.showMiniLogoIcon = state.menuSidebarCollapsed;
            }
        });
        this.user = this.commonService.getItem('user_data');
        //console.log(this.user);
        this.setSideMenu();
        // 🔴 Subscribe to the notification stream
        this.notificationService.notificationUpdated.subscribe((notificationData) => {
            this.updateSidebarNotifications(notificationData);
        });
    }

    mouseEnterOnMenuSidebar() {
        if (this.showMiniLogoIcon) {
            this.onMouseOver = true;
        }
    }

    mouseLeaveFromMenuSidebar() {
        if (this.showMiniLogoIcon) {
            this.onMouseOver = false;
        }
    }

    setSideMenu(data?) {
        this.menu = this.savedMenu;
        if (data) {
            this.accessControl = data;
        } else {
            this.accessControl = JSON.parse(localStorage.getItem('user_access'));
        }
        //console.log(this.accessControl);

        // this.accessControl.forEach(element => {
        //     element.sub_menu.forEach((sub) => {
        //         if (sub.name.toLowerCase() == 'view')
        //             this.menu.forEach((item) => {
        //                 if (item.permission_name.toLowerCase() == 'na') {
        //                     item.permission = true;
        //                 }
        //                 if (item.children) {
        //                     item.children.forEach((child) => {
        //                         if (child.permission_name.toLowerCase() == 'na') {
        //                             child.permission = true;
        //                         }
        //                         else if (child.permission_name.toLowerCase() == element.name.toLowerCase()) {
        //                             child.permission = true;
        //                             item.permission = true;
        //                         }
        //                     })
        //                 } else if (item.permission_name.toLowerCase() == element.name.toLowerCase()) {
        //                     item.permission = true;
        //                 }
        //             })
        //     })

        // })
    }

    updateSidebarNotifications(notificationData: any) {
        this.menu.forEach((section) => {
            if (section.children) {
                section.children.forEach((item) => {
                    if (item.notifyKey && notificationData.hasOwnProperty(item.notifyKey)) {
                        item.hasNotification = notificationData[item.notifyKey];
                    }
                });
            }
        });
    }


}

export const MENU = [
    {
        name: ' Dashboard',
        iconClasses: 'pe-7s-home',
        path: ['/'],
        permission: true,
        permission_name: 'na'
    },
    {
        name: ' Pilot Management',
        iconClasses: 'pe-7s-plane',
        permission: true,
        permission_name: 'na',
        children: [
            {
                name: 'Pilot List',
                iconClasses: 'pe-7s-angle-right-circle',
                path: ['/pilot/list'],
                permission: true,
                permission_name: 'na',
            },
            {
                name: 'Support Management',
                iconClasses: 'pe-7s-angle-right-circle',
                path: ['/pilot/system-management'],
                permission: true,
                permission_name: 'na',
                notifyKey: 'pilot_suppot_notify',
                hasNotification: false
            }
        ]
    },
    {
        name: ' Owner Management',
        iconClasses: 'pe-7s-user',
        permission: true,
        permission_name: 'na',
        children: [
            {
                name: 'Owner List',
                iconClasses: 'pe-7s-angle-right-circle',
                path: ['/owner/list'],
                permission: true,
                permission_name: 'na',
            },
            {
                name: 'Aircraft List',
                iconClasses: 'pe-7s-angle-right-circle',
                path: ['/owner/aircraft-list'],
                permission: true,
                permission_name: 'na',
            },
            {
                name: 'Support Management',
                iconClasses: 'pe-7s-angle-right-circle',
                path: ['/owner/system-management'],
                permission: true,
                permission_name: 'na',
                notifyKey: 'owner_suppot_notify',
                hasNotification: false
            }
        ]
    },
    {
        name: 'Global Configurations',
        iconClasses: 'pe-7s-config',
        path: ['/global/list'],
        permission: true,
        permission_name: 'na',
    },
    // {
    //     name: 'Account Types',
    //     iconClasses: 'pe-7s-note2',
    //     path: ['/account-types'],
    //     permission: true,
    //     permission_name: 'na',
    // },
    // {
    //     name: 'Access Group',
    //     iconClasses: 'pe-7s-settings',
    //     path: ['/access-group'],
    //     permission: true,
    //     permission_name: 'access group',
    // },
    // {
    //     name: 'Coupon',
    //     iconClasses: 'pe-7s-albums',
    //     path: ['/coupon'],
    //     permission: true,
    //     permission_name: 'coupon',
    // },
];
